export function LayerControls (pEditor, pLayer)
{
  var pThis = this;

  this.isObjValid = false;

  this.show = show;
  this.hide = hide;
  this.hideDo = hideDo;
  this.select = newSelect;
  this.setMovedElementXY = setMovedElementXY;
  this.deselect = deselect;
  this.delAbsElement = delAbsElement;
  this.unload = unload;

  var cutBoxCoords;
  var elementCup;
  var elementCupId = 'idEditorAbsElementCup_' + pEditor.editorId;
  var container;
  var containerId = 'idEditorAbsElementControlContainer_' + pEditor.editorId;
  var controlsId = 'idEditorAbsElementControls_' + pEditor.editorId;

  var absElement, selElement;
  var oldSelElementLeft, oldSelElementTop, oldSelElementWidth, oldSelElementHeight;
  var currentScrollLeft, currentScrollTop;
  var savedScrollLeft, savedScrollTop;
  var currentScrollLeftIFrame, currentScrollTopIFrame;
  var savedScrollLeftIFrame, savedScrollTopIFrame;
  var isSelFirst = false;
  var isSelEdit = false;
  var isSelMoving = false;
  var isSelMoved = false;
  var checkCupPositionTM = null;
  var setControlsPositionTM = null;
  var selectTM,
    hideTM = null;

  var controls = [];

  var controlResizeableParts =
    [
      {'moveTag': '6', 'cursor': 'nw-resize'},
      {'moveTag': '4', 'cursor': 'n-resize'},
      {'moveTag': '7', 'cursor': 'ne-resize'},
      {'moveTag': '3', 'cursor': 'e-resize'},
      {'moveTag': '9', 'cursor': 'nw-resize'},
      {'moveTag': '5', 'cursor': 'n-resize'},
      {'moveTag': '8', 'cursor': 'ne-resize'},
      {'moveTag': '2', 'cursor': 'e-resize'}
    ];

  var mStruct = {};
  mStruct.pushMouseLeftButton = false;
  mStruct.X = 0;
  mStruct.Y = 0;
  mStruct.left = 0;
  mStruct.top = 0;
  mStruct.width = 0;
  mStruct.height = 0;
  mStruct.elementWidth = 0;
  mStruct.elementHeight = 0;
  mStruct.elementRatio = 0;
  mStruct.shiftKey = false;
  mStruct.element = null;
  mStruct.tmSetXY = false;
  mStruct.tmMoveOut = false;

  create();


  function create ()
  {
    var i,
      controlMoveTag,
      controlLeft,
      controlRight,
      controlTop,
      controlBottom,
      controlWidth,
      controlHeight,
      controlZIndex,
      controlMarginLeft,
      controlMarginTop,
      controlVisibility,
      controlBorder,
      controlBackground,
      controlCursor,
      str = '';

    elementCup = BEditor.environment.topWindow.document.createElement('DIV');
    elementCup.id = elementCupId;
    elementCup.setAttribute('style', 'position: absolute; left: 0; top: 0; width: 0; height: 0; z-index: 37751; overflow: hidden; visibility: hidden; white-space: nowrap; cursor: move;');

    container = BEditor.environment.topWindow.document.createElement('DIV');
    container.id = containerId;
    container.setAttribute('moveTag', '1');
    container.setAttribute('style', 'position: absolute; left: 0; top: 0; width: 0; height: 0; z-index: 37753; overflow: hidden; visibility: hidden; white-space: nowrap; cursor: move;');

    for (i = 0; i < 12; i++)
    {
      controlLeft = 'auto';
      controlRight = 'auto';
      controlTop = 'auto';
      controlBottom = 'auto';
      controlMarginLeft = '';
      controlMarginTop = '';

      if (i === 0 || i === 6 || i === 7 || i === 8 || i === 10 || i === 11)
      {
        controlLeft = '0px';
      }
      else if (i === 2 || i === 3 || i === 4 || i === 9)
      {
        controlRight = '0px';
      }

      if (i === 0 || i === 1 || i === 2 || i === 8 || i === 9 || i === 11)
      {
        controlTop = '0px';
      }
      else if (i === 4 || i === 5 || i === 6 || i === 10)
      {
        controlBottom = '0px';
      }

      if (i === 1 || i === 5)
      {
        controlLeft = '50%';
        controlMarginLeft = 'margin-left: -4px;';
      }
      else if (i === 3 || i === 7)
      {
        controlTop = '50%';
        controlMarginTop = 'margin-top: -4px;';
      }

      if (i < 8)
      {
        controlMoveTag = controlResizeableParts[i]['moveTag'];
        controlWidth = '5px';
        controlHeight = '5px';
        controlZIndex = '7';
        controlVisibility = '';
        controlBorder = 'border: 1px solid #000000;';
        controlBackground = '#FFFFFF';
        controlCursor = controlResizeableParts[i]['cursor'];
      }
      else
      {
        controlMoveTag = '0';
        controlWidth = (i === 8 || i === 10) ? '100%' : '7px';
        controlHeight = (i === 9 || i === 11) ? '100%' : '7px';
        controlZIndex = '3';
        controlVisibility = 'visibility: hidden;';
        controlBorder = '';
        controlBackground = '#FFFFFF url(\'data:image/gif;base64,R0lGODlhBAAEAIAAAP///wAAACH5BAAAAAAALAAAAAAEAAQAAAIFRGComQUAOw==\') 0 0 repeat';
        controlCursor = 'move';
      }

      str += '<div id="' + controlsId + '_' + i + '" moveTag="' + controlMoveTag + '" style="position: absolute; left: ' + controlLeft + '; right: ' + controlRight + '; top: ' + controlTop + '; bottom: ' + controlBottom + '; width: ' + controlWidth + '; height: ' + controlHeight + '; z-index: ' + controlZIndex + ';' + controlMarginLeft + controlMarginTop + ' overflow: hidden;' + controlVisibility + controlBorder + ' background: ' + controlBackground + '; cursor: ' + controlCursor + '; pointer-events: auto;"></div>';
    }

    container.innerHTML = str;
    container.style.pointerEvents = 'auto';

    BEditor.environment.topWindow.document.body.appendChild(elementCup);
    BEditor.environment.topWindow.document.body.appendChild(container);

    for (i = 0; i < 12; i++)
    {
      controls[i] = BEditor.domHelpers.$(controlsId + '_' + i);

      if (i < 8)
      {
        BEditor.domHandlers.addHandler(controls[i], 'mousedown', startMoveElement);
      }
      else
      {
        BEditor.domHandlers.addHandler(controls[i], 'mousedown', changeSelect);
      }
    }

    BEditor.domHandlers.addHandler(elementCup, 'mouseover', stopHiding);
    BEditor.domHandlers.addHandler(elementCup, 'mouseover', showImageControls);
    BEditor.domHandlers.addHandler(elementCup, 'mouseout', hide);
    BEditor.domHandlers.addHandler(elementCup, 'mouseout', hideImageControls);
    BEditor.domHandlers.addHandler(elementCup, 'mousedown', select);
    BEditor.domHandlers.addHandler(elementCup, 'click', clickImageControls);

    BEditor.domHandlers.addHandler(container, 'mouseover', showImageControls);
    BEditor.domHandlers.addHandler(container, 'mouseout', hideImageControls);
    BEditor.domHandlers.addHandler(container, 'mousedown', startMoveElement);
    BEditor.domHandlers.addHandler(container, 'mouseup', selectForEdit);
    BEditor.domHandlers.addHandler(container, 'click', clickImageControls);

    BEditor.domHandlers.addHandler(pEditor.iFrameDoc, 'mousedown', deselect);
    BEditor.domHandlers.addHandler(pEditor.iFrameDoc, 'keyup', checkSelection);

    pEditor.pThis.addHandler('unreged', deselect, 'DeselectAbsElementOnBlur');
    pEditor.pThis.addHandler('imageControlMouseOver', stopHiding, 'StopHidingAbsElementCup');
    pEditor.pThis.addHandler('imageControlMouseOut', hide, 'HideAbsElementCup');

    pThis.isObjValid = true;
  }


  function show (e)
  {
    if (!pThis.isObjValid) return false;

    if (checkCupPositionTM) clearInterval(checkCupPositionTM);
    if (hideTM) clearTimeout(hideTM);

    absElement = (e && e.currentTarget) ? e.currentTarget : null;

    if (absElement && absElement != selElement)
    {
      elementCup.style.width = (absElement.offsetWidth) + 'px';
      elementCup.style.height = (absElement.offsetHeight) + 'px';

      checkCupPosition(true);

      checkCupPositionTM = setInterval(checkCupPosition, 37);
    }
  }


  function hide (e)
  {
    if (hideTM) clearTimeout(hideTM);
    hideTM = setTimeout(hideDo, 77);

    if (e && e.stopPropagation)
    {
      e.stopPropagation();
      e.preventDefault();
    }
  }


  function stopHiding (e)
  {
    if (hideTM) clearTimeout(hideTM);

    if (e && e.stopPropagation)
    {
      e.stopPropagation();
      e.preventDefault();
    }
  }


  function hideDo ()
  {
    if (checkCupPositionTM) clearInterval(checkCupPositionTM);
    if (hideTM) clearTimeout(hideTM);

    if (elementCup && elementCup.style)
    {
      elementCup.style.visibility = 'hidden';
      elementCup.style.left = 0;
      elementCup.style.top = 0;
      elementCup.style.width = 0;
      elementCup.style.height = 0;
    }

    absElement = null;
  }


  function checkCupPosition (isForced)
  {
    var currentFullScroll,
        absElementCoords;

    currentFullScroll = pEditor.isNewFullScroll ? BEditor.window.getFullScroll(pEditor.objIFrame, pEditor.$winContent, { limiters: pEditor.scrollableParents }) : BEditor.window.getScroll(pEditor.$winContent); //TODO:Dime Test scrolling contentarea & iframe
    currentScrollLeft = currentFullScroll.left;
    currentScrollLeftIFrame = BEditor.window.getScrollLeft(pEditor.iFrame);
    currentScrollTop = currentFullScroll.top;
    currentScrollTopIFrame = BEditor.window.getScrollTop(pEditor.iFrame);

    if (currentScrollLeft != savedScrollLeft || currentScrollLeftIFrame != savedScrollLeftIFrame || currentScrollTop != savedScrollTop || currentScrollTopIFrame != savedScrollTopIFrame || isForced)
    {
      savedScrollLeft = currentScrollLeft;
      savedScrollLeftIFrame = currentScrollLeftIFrame;
      savedScrollTop = currentScrollTop;
      savedScrollTopIFrame = currentScrollTopIFrame;

      cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);
      absElementCoords = BEditor.dimensions.getElementXY(absElement, pEditor.iFrame);

      elementCup.style.left = (cutBoxCoords.X - currentScrollLeft + absElementCoords.X - currentScrollLeftIFrame) + 'px';
      elementCup.style.top = (cutBoxCoords.Y - currentScrollTop + absElementCoords.Y - currentScrollTopIFrame) + 'px';

      elementCup.style.visibility = 'visible';
    }
  }


  function newSelect (element, isImmediate)
  {
    absElement = element;

    if (isImmediate)
    {
      select(null, null, true);
    }
    else
    {
      if (selectTM) clearTimeout(selectTM);
      selectTM = setTimeout(function () { select(null, null, true); }, 37);
    }
  }


  function select (e, isContinue, isSelSecond)
  {
    var obj,
        sel,
        imageObject;

    pEditor.undoRedo.isStopSaveUndo = true;

    if (selectTM) clearTimeout(selectTM);

    if (e)
    {
      e.stopPropagation();
      e.preventDefault();
    }

    if (!isContinue)
    {
      deselect();
      selElement = absElement;
    }

    if (selElement)
    {
      isSelFirst = !isSelSecond;
      isSelEdit = false;

      if (selElement.getAttribute('data-autoabs'))
      {
        selElement.setAttribute('data-selected', 'true');
      }

      sel = pEditor.iFrame.getSelection();

      if (sel)
      {
        if (BEditor.browser.isWebKit && selElement.nodeName === 'IMG' && (imageObject = pEditor.image.objectFactory.getImageObject(selElement)))
        {
          imageObject.object.click(e, isSelSecond);
        }
        else
        {
          sel.removeAllRanges();
          sel.selectAllChildren(selElement);
          sel.removeAllRanges();
          obj = pEditor.iFrameDoc.createRange();

          if (selElement.nodeName === 'IMG')
          {
            obj.selectNode(selElement);
          }
          else
          {
            obj.selectNodeContents(selElement);
            obj.collapse((selElement.innerHTML.replace(/(<br>|\s|&nbsp;)/ig, '') === ''));
          }

          sel.addRange(obj);
        }
      }

      toolbarRefreshState();

      savedScrollLeftIFrame = null;
      savedScrollTopIFrame = null;
      setControlsPosition(true);
      container.style.visibility = 'visible';
      container.style.pointerEvents = 'auto';

      hideDo();
      showImageControls();
      pEditor.range.cursor.hide();

      BEditor.domHandlers.addHandler(pEditor.iFrame, 'keydown', checkContentInAbs);
      BEditor.domHandlers.addHandler(pEditor.iFrame, 'keyup', checkContentInAbs);

      if (setControlsPositionTM) clearInterval(setControlsPositionTM);
      setControlsPositionTM = setInterval(setControlsPosition, 37);

      if (e)
      {
        startMoveElement(e);
      }
    }

    pEditor.undoRedo.saveUndoDo(true);
    pEditor.undoRedo.isStopSaveUndo = false;
  }


  function toolbarRefreshState ()
  {
    if (!pEditor.isFocused)
    {
      pEditor.pThis.focus();
    }
    else if (pEditor.pToolbar)
    {
      pEditor.pToolbar.refreshState();
    }
  }


  function checkContentInAbs (e)
  {
    var key;

    if (!e)
    {
      return true;
    }

    if (!selElement)
    {
      deselect();
      return false;
    }

    if (e.type === 'keydown')
    {
      key = ('which' in e) ? e.keyCode : e.which;

      if (BEditor.browser.isWebKit && pEditor.absImageSelected)
      {
        if (!e.ctrlKey && !e.shiftKey && !e.altKey)
        {
          if (key === 8 || key === 46)
          {
            pLayer.objectFactory.deleteAbsElement(selElement);
          }
          else if (key >= 37 && key <= 40)
          {
            keyMoveElement(key);
          }
        }

        BEditor.domHandlers.stopEvent(e);
        return false;
      }
      else if ((key === 8 || key === 46) && !isSelEdit)
      {
        pLayer.objectFactory.deleteAbsElement(selElement);
        BEditor.domHandlers.stopEvent(e);
        return false;
      }
      else if ((key === 8 || key === 46) && selElement.innerHTML.replace(/\s*\S\s*/, '') === '') //TODO:Dime Ctrl-X, Range (before, after) etc.
      {
        selElement.innerHTML = (BEditor.browser.isWebKit) ? '&nbsp;' : '<br>';
        BEditor.domHandlers.stopEvent(e);
        return false;
      }
      else if (selElement.innerHTML.replace(/(<br>|\s|&nbsp;)/ig, '') === '')
      {
        selElement.innerHTML = '';
      }
    }
    else if (e.type === 'keyup')
    {
      if (selElement.innerHTML.replace(/\s/ig, '') === '')
      {
        selElement.innerHTML = (BEditor.browser.isWebKit) ? '&nbsp;' : '<br>';
      }
    }

    return true;
  }


  function setControlsPosition (isForced)
  {
    var currentFullScroll,
        selElementCoords,
        selElementWidth,
        selElementHeight;

    if (!selElement || !container)
    {
      deselect();
      return false;
    }

    if (isSelMoving)
    {
      return true;
    }

    selElementCoords = BEditor.dimensions.getElementXY(selElement, pEditor.iFrame);
    selElementCoords.realX = selElementCoords.X - pEditor.frameSize.cloneEditableAreaCoords.paddingLeft;
    selElementCoords.realY = selElementCoords.Y - pEditor.frameSize.cloneEditableAreaCoords.paddingTop;
    selElementWidth = selElement.offsetWidth;
    selElementHeight = selElement.offsetHeight;

    if (!selElementCoords.X && !selElementCoords.Y && !selElementWidth && !selElementHeight)
    {
      selElementWidth = selElement.getAttribute('data-initwidth');
      selElementHeight = selElement.getAttribute('data-initheight');

      if (!selElementCoords.X && !selElementCoords.Y && (!selElementWidth || !selElementHeight))
      {
        deselect();
        return false;
      }
      else
      {
        selElementWidth *= 1;
        selElementHeight *= 1;
      }
    }
    else
    {
      selElement.removeAttribute('data-initwidth');
      selElement.removeAttribute('data-initheight');
    }

    currentFullScroll = pEditor.isNewFullScroll ? BEditor.window.getFullScroll(pEditor.objIFrame, pEditor.$winContent, { limiters: pEditor.scrollableParents }) : BEditor.window.getScroll(pEditor.$winContent); //TODO:Dime Test scrolling contentarea & iframe
    currentScrollLeft = currentFullScroll.left;
    currentScrollLeftIFrame = BEditor.window.getScrollLeft(pEditor.iFrame);
    currentScrollTop = currentFullScroll.top;
    currentScrollTopIFrame = BEditor.window.getScrollTop(pEditor.iFrame);

    if (isForced || selElementCoords.X != oldSelElementLeft || selElementCoords.Y != oldSelElementTop ||
      selElementWidth != oldSelElementWidth || selElementHeight != oldSelElementHeight ||
      currentScrollLeft != savedScrollLeft || currentScrollLeftIFrame != savedScrollLeftIFrame || currentScrollTop != savedScrollTop || currentScrollTopIFrame != savedScrollTopIFrame)
    {
      oldSelElementLeft = selElementCoords.X;
      oldSelElementTop = selElementCoords.Y;
      oldSelElementWidth = selElementWidth;
      oldSelElementHeight = selElementHeight;
      savedScrollLeft = currentScrollLeft;
      savedScrollLeftIFrame = currentScrollLeftIFrame;
      savedScrollTop = currentScrollTop;
      savedScrollTopIFrame = currentScrollTopIFrame;

      cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);

      container.style.left = (cutBoxCoords.X - currentScrollLeft + selElementCoords.X - currentScrollLeftIFrame - 7) + 'px';
      container.style.top = (cutBoxCoords.Y - currentScrollTop + selElementCoords.Y - currentScrollTopIFrame - 7) + 'px';
      container.style.width = (selElementWidth + 14) + 'px';
      container.style.height = (selElementHeight + 14) + 'px';
    }
  }


  function changeSelect (e)
  {
    visibilityControls(false);
    select(e, true);
  }


  function visibilityControls (st)
  {
    var i;

    for (i = 8; i < 12; i++)
    {
      controls[i].style.visibility = (st) ? 'visible' : 'hidden';
    }
  }


  function selectForEdit (e, isNewElement)
  {
    pEditor.undoRedo.isStopSaveUndo = true;

    if (!isSelFirst)
    {
      if (selElement && selElement.nodeName !== 'IMG' && (!isSelMoved || isNewElement))
      {
        isSelEdit = true;

        if (selElement.getAttribute('data-autoabs'))
        {
          selElement.setAttribute('data-selected', 'true');
        }

        container.style.pointerEvents = 'none';

        if (BEditor.browser.isWebKit || BEditor.browser.isGecko)
        {
          setControlsPosition(true);
          visibilityControls(true);

          BEditor.domHandlers.addHandler(pEditor.iFrameDoc, 'keydown', fixKey);
        }
        else
        {
          container.style.visibility = 'hidden';
          hideDo();
        }

        pEditor.range.cursor.show(selElement, false);
      }
      else
      {
        if (isSelMoved)
        {
          isSelMoved = false;
        }
      }
    }
    else
    {
      isSelFirst = false;
    }

    pEditor.undoRedo.saveUndoDo(true);
    pEditor.undoRedo.isStopSaveUndo = false;
  }


  function fixKey (e)
  {
    if (!e) return false;

    var currentSelection, currentRange;
    var key = e.which;
    var brNode, textNode;

    if (key == 13)
    {
      e.stopPropagation();
      e.preventDefault();
      currentRange = pEditor.range.getCurrent();

      if (currentRange)
      {
        brNode = pEditor.iFrameDoc.createElement('BR');
        currentRange.insertNode(brNode);
        textNode = pEditor.iFrameDoc.createTextNode('.');

        if (brNode.nextSibling)
        {
          brNode.parentNode.insertBefore(textNode, brNode.nextSibling);
        }
        else
        {
          brNode.parentNode.appendChild(textNode);
        }

        currentSelection = pEditor.range.selection.getCurrent();
        currentSelection.removeAllRanges();
        currentRange = pEditor.iFrameDoc.createRange();
        currentRange.selectNode(textNode);
        currentSelection.addRange(currentRange);
        pEditor.iFrameDoc.execCommand('inserthtml', false, '');
      }
    }
  }


  function showImageControls ()
  {
    var element = absElement || selElement,
        imageObject;

    if (element && element.nodeName.toUpperCase() === 'IMG')
    {
      imageObject = pEditor.image.objectFactory.getImageObject(element);

      if (imageObject)
      {
        imageObject.object.mouseOver();
      }
    }
  }


  function hideImageControls ()
  {
    var element = absElement || selElement,
        imageObject;

    if (element && element.nodeName.toUpperCase() === 'IMG')
    {
      imageObject = pEditor.image.objectFactory.getImageObject(element);

      if (imageObject)
      {
        imageObject.object.mouseOut();
      }
    }
  }


  function clickImageControls (e)
  {
    var element = absElement || selElement,
        imageObject;

    if (element && element.nodeName.toUpperCase() === 'IMG')
    {
      imageObject = pEditor.image.objectFactory.getImageObject(element);

      if (imageObject)
      {
        imageObject.object.click(e, false);
      }
    }
  }


  function startMoveElement (e)
  {
    var currentFullScroll;

    if (e && e.currentTarget && container && selElement)
    {
      e.stopPropagation();
      e.preventDefault();

      if (selElement.nodeName.toUpperCase() === 'IMG')
      {
        pEditor.image.controls.hideControlsTemp();
      }

      isSelMoving = true;
      pEditor.isAbsElementMoving = true;

      currentFullScroll = pEditor.isNewFullScroll ? BEditor.window.getFullScroll(pEditor.objIFrame, pEditor.$winContent, { limiters: pEditor.scrollableParents }) : BEditor.window.getScroll(pEditor.$winContent); //TODO:Dime Test scrolling contentarea & iframe
      currentScrollLeft = currentFullScroll.left;
      currentScrollLeftIFrame = BEditor.window.getScrollLeft(pEditor.iFrame);
      currentScrollTop = currentFullScroll.top;
      currentScrollTopIFrame = BEditor.window.getScrollTop(pEditor.iFrame);

      mStruct.X = e.screenX;
      mStruct.Y = e.screenY;
      mStruct.left = container.offsetLeft - (cutBoxCoords.X - currentScrollLeft);
      mStruct.top = container.offsetTop - (cutBoxCoords.Y - currentScrollTop);
      mStruct.width = container.offsetWidth;
      mStruct.height = container.offsetHeight;
      mStruct.elementWidth = mStruct.width;
      mStruct.elementHeight = mStruct.height;
      mStruct.elementRatio = selElement.offsetWidth / selElement.offsetHeight;
      mStruct.element = e.currentTarget;
      mStruct.moveTag = (mStruct.element.getAttribute('moveTag') * 1) || 1;

      cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);
      cutBoxCoords.width = pEditor.cutBox.offsetWidth;
      cutBoxCoords.height = pEditor.cutBox.offsetHeight;

      pEditor.iFrameDoc.body.style.width = pEditor.iFrameDoc.body.offsetWidth + 'px';
      pEditor.iFrameDoc.body.style.overflow = 'hidden';
      pEditor.iFrameDoc.body.style.overflowX = 'hidden';

      if (!pEditor.frameSize.isEditorSizeFixed)
      {
        pEditor.iFrameDoc.body.style.height = '';
        pEditor.iFrameDoc.body.style.cssText += 'height: ' + pEditor.iFrameDoc.body.offsetHeight + 'px !important';
        pEditor.iFrameDoc.body.style.overflowY = (BEditor.browser.isIE ? 'hidden' : 'visible');
        pEditor.iFrameDoc.getElementsByTagName('HTML')[0].style.overflowX = 'hidden';
      }

      moveElement(e);
    }
    else
    {
      moveElementDo(e, null);
    }
  }


  function moveElement (e, element)
  {
    var eType, eButton, eX, eY;

    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);

    if (e && mStruct.element)
    {
      e.stopPropagation();
      e.preventDefault();

      eType = e.type;
      eButton = e.button;
      eX = e.screenX;
      eY = e.screenY;
      mStruct.shiftKey = e.shiftKey;

      moveElementDo(e, eType, eButton, eX, eY);
    }
    else
    {
      moveElementDo(e, null);
    }
  }


  function moveElementDo (e, eType, eButton, eX, eY)
  {
    var tmpLeft,
      tmpTop,
      tmpWidth,
      tmpHeight,
      deltaX,
      deltaY,
      deltaInvX,
      deltaInvY;

    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);

    if (!selElement || !container)
    {
      deselect();
      return false;
    }

    if (eType == null)
    {
      isSelMoving = false;
      pEditor.isAbsElementMoving = false;
      mStruct.pushMouseLeftButton = false;
      removeAbsElementHandler();
      setMovedElementXY();
      pEditor.undoRedo.isStopSaveUndo = false;
      pEditor.undoRedo.saveUndo(true);

      if (selElement.nodeName.toUpperCase() === 'IMG')
      {
        pEditor.image.controls.showControlsTemp();
      }
    }
    else
    {
      if (eType == 'mousedown')
      {
        pEditor.undoRedo.isStopSaveUndo = true;
        pEditor.contentChecker.setExcludeWordCheck();

        if (eButton == 0 || eButton == 1)
        {
          isSelMoving = true;
          pEditor.isAbsElementMoving = true;
          mStruct.pushMouseLeftButton = true;
          addAbsElementHandler();
        }
        else
        {
          isSelMoving = false;
          pEditor.isAbsElementMoving = false;
          mStruct.pushMouseLeftButton = false;
          removeAbsElementHandler();
          setMovedElementXY();
        }
      }
      else if (eType == 'mouseup' || eType == 'mouseout')
      {
        isSelMoving = false;
        pEditor.isAbsElementMoving = false;
        mStruct.pushMouseLeftButton = false;
        removeAbsElementHandler();
        setMovedElementXY();
        pEditor.undoRedo.isStopSaveUndo = false;
        pEditor.undoRedo.saveUndo(true);

        if (selElement.nodeName.toUpperCase() === 'IMG')
        {
          pEditor.image.controls.showControlsTemp();
        }
      }
      else if (eType == 'mousemove' && mStruct.pushMouseLeftButton)
      {
        if (mStruct.moveTag)
        {
          tmpLeft = null;
          tmpTop = null;
          tmpWidth = null;
          tmpHeight = null;
          deltaX = eX - mStruct.X;
          deltaInvX = mStruct.X - eX;
          deltaY = eY - mStruct.Y;
          deltaInvY = mStruct.Y - eY;

          if(mStruct.moveTag === 1)
          {
            mStruct.left += deltaX;
            mStruct.top += deltaY;
            tmpLeft = mStruct.left;
            tmpTop = mStruct.top;

            if (tmpLeft + mStruct.width - 7 > cutBoxCoords.width)
            {
              tmpLeft = cutBoxCoords.width - (mStruct.width - 7);
            }

            if (tmpLeft + 7 < 0)
            {
              tmpLeft = -7;
            }

            if (tmpTop + mStruct.height - 7 > cutBoxCoords.height)
            {
              tmpTop = cutBoxCoords.height - (mStruct.height - 7);
            }

            if (tmpTop + 7 < 0)
            {
              tmpTop = -7;
            }
          }
          else
          {
            if(mStruct.moveTag === 2 || mStruct.moveTag === 6 || mStruct.moveTag === 8)
            {
              mStruct.left += deltaX;
              mStruct.width += deltaInvX;
              tmpLeft = mStruct.left;
              tmpWidth = mStruct.width;

              if (tmpWidth < 17)
              {
                tmpLeft = null;
                tmpWidth = null;
              }
              else if (tmpLeft + 7 < 0)
              {
                tmpLeft = -7;
                tmpWidth = null;
              }
            }
            else if(mStruct.moveTag === 3 || mStruct.moveTag === 7 || mStruct.moveTag === 9)
            {
              mStruct.width += deltaX;
              tmpWidth = mStruct.width;

              if (tmpWidth < 17)
              {
                tmpWidth = null;
              }
              else if (mStruct.left + tmpWidth - 7 > cutBoxCoords.width)
              {
                tmpWidth = cutBoxCoords.width - (mStruct.left - 7);
              }
            }

            if(mStruct.moveTag === 4 || mStruct.moveTag === 6 || mStruct.moveTag === 7)
            {
              mStruct.top += deltaY;
              mStruct.height += deltaInvY;
              tmpTop = mStruct.top;
              tmpHeight = mStruct.height;

              if (tmpHeight < 17)
              {
                tmpTop = null;
                tmpHeight = null;
              }
              else if (tmpTop + 7 < 0)
              {
                tmpTop = -7;
                tmpHeight = null;
              }
            }
            else if(mStruct.moveTag === 5 || mStruct.moveTag === 8 || mStruct.moveTag === 9)
            {
              mStruct.height += deltaY;
              tmpHeight = mStruct.height;

              if (tmpHeight < 17)
              {
                tmpHeight = null;
              }
              else if (mStruct.top + tmpHeight - 7 > cutBoxCoords.height)
              {
                tmpHeight = cutBoxCoords.height - (mStruct.top - 7);
              }
            }
          }

          if (tmpLeft !== null)
          {
            container.style.left = ((cutBoxCoords.X - currentScrollLeft) + tmpLeft) + 'px';
            selElement.style.left = (tmpLeft + currentScrollLeftIFrame + 7) + 'px';

            mStruct.X = eX;
          }

          if (tmpTop !== null)
          {
            container.style.top = ((cutBoxCoords.Y - currentScrollTop) + tmpTop) + 'px';
            selElement.style.top = (tmpTop + currentScrollTopIFrame + 7) + 'px';

            mStruct.Y = eY;
          }

          if (tmpWidth !== null)
          {
            container.style.width = tmpWidth + 'px';
            selElement.style.width = (tmpWidth - 14) + 'px';

            mStruct.X = eX;
          }

          if (tmpHeight !== null)
          {
            container.style.height = tmpHeight + 'px';
            selElement.style.height = (tmpHeight - 14) + 'px';

            mStruct.Y = eY;
          }

          isSelMoved = true;
        }
      }
    }
  }


  function moveOut()
  {
    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);
    mStruct.tmMoveOut = setTimeout(function() { moveElementDo(null, null); }, 100);
  }


  function moveOver()
  {
    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);
  }


  function keyMoveElement (key)
  {
    if (container)
    {
      switch (key)
      {
        case 37:
          container.style.left = (container.offsetLeft - 1) + 'px';
          selElement.style.left = (selElement.offsetLeft - 1) + 'px';
          break;

        case 38:
          container.style.top = (container.offsetTop - 1) + 'px';
          selElement.style.top = (selElement.offsetTop - 1) + 'px';
          break;

        case 39:
          container.style.left = (container.offsetLeft + 1) + 'px';
          selElement.style.left = (selElement.offsetLeft + 1) + 'px';
          break;

        case 40:
          container.style.top = (container.offsetTop + 1) + 'px';
          selElement.style.top = (selElement.offsetTop + 1) + 'px';
          break;
      }
    }
  }


  function setMovedElementXY ()
  {
    var currentFullScroll,
        containerLeft,
        containerTop,
        containerWidth,
        containerHeight,
        minOutX,
        minOutY;

    cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);
    cutBoxCoords.width = pEditor.cutBox.offsetWidth;
    cutBoxCoords.height = pEditor.cutBox.offsetHeight;

    currentFullScroll = pEditor.isNewFullScroll ? BEditor.window.getFullScroll(pEditor.objIFrame, pEditor.$winContent, { limiters: pEditor.scrollableParents }) : BEditor.window.getScroll(pEditor.$winContent); //TODO:Dime Test scrolling contentarea & iframe
    currentScrollLeft = currentFullScroll.left;
    currentScrollLeftIFrame = BEditor.window.getScrollLeft(pEditor.iFrame);
    currentScrollTop = currentFullScroll.top;
    currentScrollTopIFrame = BEditor.window.getScrollTop(pEditor.iFrame);

    containerLeft = container.offsetLeft - (cutBoxCoords.X - currentScrollLeft);
    containerTop = container.offsetTop - (cutBoxCoords.Y - currentScrollTop);
    containerWidth = Math.max(container.offsetWidth, 15);
    containerHeight = Math.max(container.offsetHeight, 15);
    minOutX = (containerWidth - 17 > 0) ? 17 : Math.abs(containerWidth - 7);
    minOutY = (containerHeight - 17 > 0) ? 17 : Math.abs(containerHeight - 7);

    if (containerLeft + minOutX > cutBoxCoords.width)
    {
      containerLeft = cutBoxCoords.width - minOutX;
    }

    if (containerLeft + containerWidth - minOutX < 0)
    {
      containerLeft = minOutX - containerWidth;
    }

    if (containerTop + minOutY > cutBoxCoords.height)
    {
      containerTop = cutBoxCoords.height - minOutY;
    }

    if (containerTop + containerHeight - minOutY < 0)
    {
      containerTop = minOutY - containerHeight;
    }

    container.style.left = ((cutBoxCoords.X - currentScrollLeft) + containerLeft) + 'px';
    container.style.top = ((cutBoxCoords.Y - currentScrollTop) + containerTop) + 'px';
    container.style.width = containerWidth + 'px';
    container.style.height = containerHeight + 'px';

    selElement.style.left = (containerLeft + currentScrollLeftIFrame + 7) + 'px';
    selElement.style.top = (containerTop + currentScrollTopIFrame + 7) + 'px';
    selElement.style.width = (containerWidth - 14) + 'px';
    selElement.style.height = (containerHeight - 14) + 'px';

    pEditor.iFrameDoc.body.style.width = '100%';
    pEditor.iFrameDoc.body.style.overflow = 'auto';
    pEditor.iFrameDoc.body.style.overflowX = !pEditor.frameSize.isEditorNoScroll ? 'auto' : 'hidden';

    if (!pEditor.frameSize.isEditorSizeFixed)
    {
      pEditor.iFrameDoc.body.style.height = '';
      pEditor.iFrameDoc.body.style.cssText += 'height: auto !important';
      pEditor.iFrameDoc.body.style.overflowY = (BEditor.browser.isIE ? 'hidden' : 'visible');
      pEditor.iFrameDoc.getElementsByTagName('HTML')[0].style.overflowX = 'auto';
    }
    else
    {
      pEditor.iFrameDoc.body.style.overflowY = (BEditor.browser.isWebKit ? 'visible' : 'hidden');
    }
  }


  function addAbsElementHandler ()
  {
    mStruct.element.addEventListener('mouseout', moveOut, false);
    mStruct.element.addEventListener('mouseover', moveOver, false);

    pEditor.iFrameDoc.addEventListener('mousemove', moveElement, false);
    pEditor.iFrameDoc.addEventListener('mouseup', moveElement, false);
    pEditor.iFrameDoc.addEventListener('mouseout', moveOut, false);
    pEditor.iFrameDoc.addEventListener('mouseover', moveOver, false);

    pEditor.$winContent.document.addEventListener('mousemove', moveElement, false);
    pEditor.$winContent.document.addEventListener('mouseup', moveElement, false);
    pEditor.$winContent.document.addEventListener('mouseout', moveOut, false);
    pEditor.$winContent.document.addEventListener('mouseover', moveOver, false);

    BEditor.environment.topWindow.document.addEventListener('mousemove', moveElement, false);
    BEditor.environment.topWindow.document.addEventListener('mouseup', moveElement, false);
    BEditor.environment.topWindow.document.addEventListener('mouseout', moveOut, false);
    BEditor.environment.topWindow.document.addEventListener('mouseover', moveOver, false);
  }


  function removeAbsElementHandler ()
  {
    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);

    mStruct.element.removeEventListener('mouseout', moveOut, false);
    mStruct.element.removeEventListener('mouseover', moveOver, false);

    pEditor.iFrameDoc.removeEventListener('mousemove', moveElement, false);
    pEditor.iFrameDoc.removeEventListener('mouseup', moveElement, false);
    pEditor.iFrameDoc.removeEventListener('mouseout', moveOut, false);
    pEditor.iFrameDoc.removeEventListener('mouseover', moveOver, false);

    pEditor.$winContent.document.removeEventListener('mousemove', moveElement, false);
    pEditor.$winContent.document.removeEventListener('mouseup', moveElement, false);
    pEditor.$winContent.document.removeEventListener('mouseout', moveOut, false);
    pEditor.$winContent.document.removeEventListener('mouseover', moveOver, false);

    BEditor.environment.topWindow.document.removeEventListener('mousemove', moveElement, false);
    BEditor.environment.topWindow.document.removeEventListener('mouseup', moveElement, false);
    BEditor.environment.topWindow.document.removeEventListener('mouseout', moveOut, false);
    BEditor.environment.topWindow.document.removeEventListener('mouseover', moveOver, false);
  }


  function delAbsElement ()
  {
    var element;

    if (selElement)
    {
      element = selElement;
      pEditor.undoRedo.saveUndo(true);
      deselect();
      pEditor.range.cursor.show();
      element.parentNode.removeChild(element);
      absElement = null;
      pEditor.image.currentImage = null;
    }
  }


  function checkSelection ()
  {
    var i,
        pointers = [],
        isPointersTrue = [false, false],
        parentElement,
        currentRange = pEditor.range.getCurrent(true);

    if (!currentRange.collapsed)
    {
      pointers[0] = currentRange.startContainer;
      pointers[1] = currentRange.endContainer;

      for (i = 0; i < 2; i++)
      {
        parentElement = pointers[i];

        while (parentElement && parentElement.nodeName !== 'BODY')
        {
          if (parentElement === selElement)
          {
            isPointersTrue[i] = true;
            break;
          }

          parentElement = parentElement.parentNode;
        }
      }

      if (!isPointersTrue[0] || !isPointersTrue[1])
      {
        deselect();
      }
    }
  }


  function deselect (e, sender, eName)
  {
    var selElementHTML;

    if (!e || !e.target || !selElement || e.target != selElement)
    {
      if (setControlsPositionTM) clearInterval(setControlsPositionTM);

      if (container)
      {
        container.style.visibility = 'hidden';
        visibilityControls(false);
      }

      if (selElement)
      {
        pEditor.undoRedo.isStopSaveUndo = true;

        if (selElement.getAttribute('data-selected'))
        {
          selElement.removeAttribute('data-selected');
        }

        if (selElement.nodeName.toUpperCase() != 'IMG')
        {
          selElementHTML = selElement.innerHTML;

          if ((/\S&nbsp;$/i).test(selElementHTML))
          {
            selElement.innerHTML = selElementHTML.replace(/(\S)&nbsp;$/i, '$1');
          }
        }

        pEditor.undoRedo.saveUndoDo(true);
        pEditor.undoRedo.isStopSaveUndo = false;
      }

      isSelMoving = false;
      pEditor.isAbsElementMoving = false;
      selElement = null;
      pEditor.image.webkitSelectedImage = null;

      if (pEditor.absImageSelected)
      {
        pEditor.absImageSelected = null;
        pEditor.range.cursor.show();
        pEditor.setEnabledCommand(true);
      }

      if (!eName || eName !== 'unreged')
      {
        toolbarRefreshState();
      }
    }
  }


  function unload ()
  {
    if (checkCupPositionTM) clearInterval(checkCupPositionTM);
    if (hideTM) clearTimeout(hideTM);
    if (setControlsPositionTM) clearInterval(setControlsPositionTM);

    if (elementCup && elementCup.parentNode)
    {
      BEditor.domHandlers.removeHandler(elementCup, 'mouseover', stopHiding);
      BEditor.domHandlers.removeHandler(elementCup, 'mouseout', hide);

      try { elementCup.parentNode.removeChild(elementCup); } catch (err) {}
    }

    elementCup = null;

    if (container && container.parentNode)
    {
      try { container.parentNode.removeChild(container); } catch (err) {}
    }

    container = null;
  }
}